import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { SecondaryButton } from '../../Shared/Button'

export default function ArchivePrompt({ eventTitle, onCancel, onConfirm }) {
  const { t } = useTranslation()

  return (
    <div className="yes-no-prompt-prompt">
      <div className="yes-no-prompt_content">
        <h1>{t('Recommendations.archiveEvent.title')}</h1>
        <p>{t('Recommendations.archiveEvent.description1', { eventTitle })}</p>
        <p>{t('Recommendations.archiveEvent.description2')}</p>
      </div>
      <div className="yes-no-prompt_footer">
        <SecondaryButton
          text={t('Recommendations.archiveEvent.cancel')}
          onClick={onCancel}
          color="navy"
        />
        <SecondaryButton
          className="bt"
          text={t('Recommendations.archiveEvent.confirm')}
          onClick={onConfirm}
        />
      </div>
    </div>
  )
}

ArchivePrompt.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  eventTitle: PropTypes.string.isRequired,
}
